type AppChipProps<T> = {
  value: T | null;
  getColor: (value: T) => string;
  title?: string;
  displayValue?: string | null;
};

export const AppChip = <T,>({ value, getColor, title, displayValue }: AppChipProps<T>) => {
  const colorClass = value !== null && value !== undefined ? getColor(value) : 'default';

  return (
    <span className={`custom_chip px-3 custom_chip--rounded custom_chip--${colorClass}`}>
      {value !== null && value !== undefined ? (
        <span className="overflow-ellipsis text-capitalize" title={title ?? displayValue ?? String(value)}>
          {displayValue ?? String(value)}
        </span>
      ) : (
        '-'
      )}
    </span>
  );
};

export default AppChip;
